import React, {Component} from 'react';
import './HomePage.css';
import confettiBanner from '../../assets/Confetti@1x.png'
import logoBlack from '../../assets/logo_thankfully_black_1x.png'
import homepage_video from '../../assets/homepage_video.mp4'
import screenshot1 from '../../assets/screenshot1.png'
import screenshot2 from '../../assets/screenshot2.png'
import thumbnail0 from '../../assets/thumbnail_thankyoucard.png'
import thumbnail1 from '../../assets/thumbnail1_cicero.png'
import thumbnail2 from '../../assets/thumbnail2_ellen.png'
import thumbnail3 from '../../assets/thumbnail3_ward.png'
import thumbnail4 from '../../assets/thumbnail4_gertrude.png'
import thumbnail5 from '../../assets/thumbnail5_stein.png'
import thumbnail6 from '../../assets/thumbnail6_walker.png'
import thumbnail7 from '../../assets/thumbnail7_caroleking.png'
import emoji1 from '../../assets/emoji1.png'
import emoji2 from '../../assets/emoji2.png'
import emoji3 from '../../assets/emoji3.png'
import emoji4 from '../../assets/emoji4.png'
import emoji5 from '../../assets/emoji5.png'
import emoji6 from '../../assets/emoji6.png'
import emoji7 from '../../assets/emoji7.png'
import science1 from '../../assets/icon_science1.png'
import science2 from '../../assets/icon_science2.png'
import science3 from '../../assets/icon_science3.png'
import RequestAccessButton from '../RequestAccessButton/RequestAccessButton.js'
import HomeDownloadPage from '../HomeDownloadPage/HomeDownloadPage.js'
import ContactPage from '../ContactPage/ContactPage.js'
import {Link} from 'react-router-dom'
import embedCssOverride from '../embedCssOverride'
import Footer from '../Footer';

export class Home extends Component {
    render() {
        return (
            <div>
                <section id="hero" className="hero hero-1">
                    <div className="content bg-black bg-parallax block-process-1 padding-top-130 padding-bot-180 resp_pt-110 resp_pt-100">
                        <div className="container">
                                <div className="row">
                                    <div className="col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 f-none mx-auto">
                                        <div className="header text-center scroll-animated-from-bottom">
                                            <h3><strong>Thankfully</strong> is a mobile app on a mission to bring more
                                                gratitude and positivity into your life - and into the world. we're an
                                                antidote to all of the negativity and anxiety that surrounds us these
                                                days.</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="pagination-top mt-20 pagination-custom-1 mx--100">
                                    <div className="owl-banner_demo">
                                        <div className="row">
                                            <div className="col-md-4 col-sm-4 col-xs-4 resp_p-10">
                                                <div><img src="assets/images/about/hero1.png" alt="banner img" className="img-responsive scroll-animated-from-bottom" /></div>
                                            </div>
                                            <div className="col-md-4 col-sm-4 col-xs-4 resp_p-10">
                                                <div className="center-mode"><img src="assets/images/about/hero2.png" alt="banner img" className="img-responsive scroll-animated-from-bottom" /></div>
                                            </div>    
                                            <div className="col-md-4 col-sm-4 col-xs-4 resp_p-10">
                                                <div><img src="assets/images/about/hero3.png" alt="banner img" className="img-responsive scroll-animated-from-bottom" /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                            
                        </div>
                    </div>

                    <div className="background-content page-enter-animated">
                        <div className="level-1">
                            <div className="bg-overlay"></div>
                            <div className="bg-pattern"></div>
                            <div id="canvas">
                                <canvas className="bg-effect layer" data-depth="0.2"></canvas>
                            </div>
                        </div>
                        <div className="level-2">
                            <div className="dzsparallaxer auto-init allbody"
                                 data-options="{  mode_scroll: 'fromtop', animation_duration: '2' , direction: 'reverse' }">
                                <div className="dzsparallaxer--target">
                                    <div className="bg-image layer" data-depth="0.04"></div>
                                    <div className="bg-video layer" data-depth="0.04"></div>
                                    <div className="bg-color layer" data-depth="0.04"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <nav className="navigation-main">
                    <div className="container">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle" data-toggle="collapse"
                                    data-target="#navbar">
                                <span className="ti-menu"></span>
                            </button>
                            <a className="navbar-brand" href="#"><img className="img-responsive"
                                                                      src="assets/images/logo-black.png"
                                                                      alt=""/></a>
                        </div>
                        <div id="navbar" className="navbar-collapse collapse">
                            <ul className="navigation-items nav navbar-nav navbar-right">
                                <li><a className="phantom" href="#hero">Hello World</a></li>
                                <li><a href="#meet">Meet Thankfully</a></li>
                                <li><a className="btn-menu" href="#download">Download</a></li>

                            </ul>
                        </div>
                    </div>
                </nav>

                <section id="saythanks">
                    <div className="content bg-white block-about-1 padding-top-50 padding-bot-130 resp_pb-70">
                        <div className="container text-center">
                            <div className="header text-center scroll-animated-from-bottom">
                                <div className="col-md-8 col-md-offset-2 f-none mx-auto">
                                    <h3 className="resp_mt-0"><strong>Because Gratitude is Your Hidden Superpower</strong></h3><br/>
                                    <h1><img className="img-responsive power_img"
                                             src="assets/images/about/emoji-superhero.png" alt="image"/></h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-10 col-md-offset-1 f-none mx-auto">
                                    <h4 className="scroll-animated-from-bottom">
                                        <b>Thankfully</b> is all about helping you to give and receive more thanks.
                                        Because when you pay more attention and give thanks for all the good that's in
                                        your life,
                                        you feel happier, less stressed, and more optimistic about the world and the
                                        state of humanity.<br/><br/>.
                                    </h4>
                                </div>
                                <div className="col-sm-12">
                                    <img className="img-responsive scroll-animated-from-bottom"
                                         src="assets/images/about/brain-heart.png" alt="image"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="feelrich">
                    <div className="content bg-black bg-parallax block-service-1 padding-top-100 padding-bot-130 resp_pt-50 resp_pb-50">
                        <div className="container text-center">
                            <div className="header text-center">
                                <div className="col-md-8 col-md-offset-2 f-none mx-auto">
                                    <h3><strong>Conjure it up - Anytime, Anywhere</strong></h3><br/>
                                    <h2>🧞‍ 😇 🧘️</h2>
                                </div>
                            </div>
                            <div className="tab-content scroll-animated-from-bottom">
                                <div className="tab-pane fade in active" id="service-data-1">
                                    <div className="row">
                                        <div className="col-sm-10 col-md-offset-1 f-none mx-auto">
                                            <h4>And the best part? You can conjure up gratitude whenever you’d like,
                                                wherever you are.
                                                All you need to do is carve out a minute or two in your day to give a
                                                little thanks -
                                                and you’re sure to get a whole lot back in return.</h4>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="dzsparallaxer auto-init do-not-set-js-height"
                             data-options="{  mode_scroll: 'normal', animation_duration: '0' , direction: 'reverse' }">
                            <div className="divimage dzsparallaxer--target"
                                 style={{"backgroundImage": "url(assets/images/parallax/1.jpg)"}}></div>
                            <div className="bg-overlay-section"></div>
                        </div>
                    </div>
                </section>
                <section id="meet">
                    <div className="content bg-white block-work-1 padding-top-90 resp_pt-50 padding-bot-50">
                        <div className="container text-center">
                            <div className="header text-center scroll-animated-from-bottom">
                                <h3><strong>Thankfully, You've Got Thankfully</strong></h3>
                            </div>
                            <div className="row">
                                <div className="col-sm-10 text-center col-md-offset-1 f-none mx-auto">
                                    <h4 className="scroll-animated-from-bottom">
                                        This is where we come in. <b>Thankfully</b> is designed to help you notice and
                                        remember all of the good; to help make sure that the special people around you
                                        aren't taken for granted; to help you Just Say Thanks - more often. <b>Thankfully</b>,
                                        you’ve got us!
                                        <br/><br/>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="features">
                    <div className="content bg-black bg-parallax block-process-1 padding-top-50 pb-50">
                        <div className="container">
                            <div className="header text-center scroll-animated-from-bottom">
                                <h3><strong>What Can Thankfully Do for You?</strong></h3>
                            </div>

                            <div className="slider-container">
                                <div id="owl-demo" className="owl-carousel owl-demo">
                                    <div className="item"><img src="assets/images/about/scroll1.png" alt="Owl Image"/>
                                    </div>
                                           
                                    <div className="item"><img src="assets/images/about/scroll2.png" alt="Owl Image"/>
                                    </div>
                                           
                                    <div className="item"><img src="assets/images/about/scroll3.png" alt="Owl Image"/>
                                    </div>
                                         
                                    <div className="item"><img src="assets/images/about/scroll4.png" alt="Owl Image"/>
                                    </div>
                                         
                                    <div className="item"><img src="assets/images/about/scroll5.png" alt="Owl Image"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="dzsparallaxer auto-init do-not-set-js-height"
                             data-options="{  mode_scroll: 'normal', animation_duration: '0' , direction: 'reverse' }">
                            <div className="divimage dzsparallaxer--target"
                                 style={{"backgroundImage": "url(assets/images/parallax/2.jpg)"}}></div>
                            <div className="bg-overlay-section"></div>
                        </div>
                    </div>
                </section>
                <Footer/>
            </div>
    )

    }
    }

    export default Home;


// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js